<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="setting">
        <p>Reports</p>
        <div class="setting__nav">
          <!-- <div
            class="setting__nav--item"
            v-bind:style="[summaryReport?{color: '#5099de', borderBottom: '5px solid #5099de'}:{color: '#c7c7c7', borderBottom: '5px solid transparent'}]"
            @click="openSummaryReport"
          >Summary Reports</div>-->
          <!-- <div
            class="setting__nav--item"
            v-bind:style="[payrollHistory?{color: '#5099de', borderBottom: '5px solid #5099de'}:{color: '#c7c7c7', borderBottom: '5px solid transparent'}]"
            @click="openPayrollHistory"
          >Payroll History</div>-->
          <div
            class="setting__nav--item"
            v-bind:style="[
              payrollHistory
                ? { color: '#5099de', borderBottom: '5px solid #5099de' }
                : { color: '#c7c7c7', borderBottom: '5px solid transparent' }
            ]"
          >
            Payroll History
          </div>
        </div>
        <!-- <div v-show="summaryReport">
          <SummaryReport />
        </div>-->
        <div v-show="payrollHistory">
          <PayrollHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import PayrollHistory from "./payollHistory";
// import SummaryReport from "./summaryReport";

export default {
  name: "Setting",
  components: {
    Header,
    Sidebar,
    PayrollHistory
    // SummaryReport
  },
  data() {
    return {
      item: "report",
      summaryReport: false,
      payrollHistory: true
    };
  },
  methods: {
    openSummaryReport() {
      this.summaryReport = true;
      this.payrollHistory = false;
    },
    openPayrollHistory() {
      this.summaryReport = false;
      this.payrollHistory = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.setting {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  > p {
    font-size: 2.083vw;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .setting__div {
    border-top: 1px solid #caced5;
  }
}

.setting__nav {
  margin-top: 40px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  border-bottom: 1px solid #caced5;

  > .setting__nav--item {
    float: left;
    padding: 0 10px;
    width: 25%;
    font-size: 1.25vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    padding-bottom: 20px;
    cursor: pointer;
  }
}
</style>
